import { render, staticRenderFns } from "./FireExtinguishers.vue?vue&type=template&id=42f7b0d4&scoped=true&"
import script from "./FireExtinguishers.vue?vue&type=script&lang=js&"
export * from "./FireExtinguishers.vue?vue&type=script&lang=js&"
import style0 from "./FireExtinguishers.vue?vue&type=style&index=0&id=42f7b0d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f7b0d4",
  null
  
)

export default component.exports